module.exports = __webpack_public_path__ + "static/img/qq.762ef26a.svg";